import "./RaikoCustomEditor2.scss"
import RaikoEditorHtmlEditor from "./htmlEditor/RaikoEditorHtmlEditor";
import {useEffect, useState} from "react";
import InternalImageSelector from "./internalImageSelector/InternalImageSelector";
import RaikoEditorItemsContainer from "./raikoEditorItemsContainer/RaikoEditorItemsContainer";
import InternalImageSliderSelector from "./internalImageSliderSelector/InternalImageSliderSelector";
import CreateNewItem from "./createNewItem/CreateNewItem";
import InternalVideoSelector from "./internalVideoSelector/InternalVideoSelector";
import "./RaikoCustomEditorStyleSheet.scss"
import InternalAudioSelector from "./internalAudioSelector/InternalAudioSelector";
import {RaikoErrorSection, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import {RaikoErrorSectionVectors} from "../../util/RaikoErrorSectionVectors";


export default function RaikoCustomEditor2(
    {
        value = [],
        setValue
    }
) {

    const [firstInitial, setFirstInitial] = useState(false)

    useEffect(() => {

        if (value && value.length > 0 && !firstInitial) {
            const _value = []
            value.forEach((item) => {

                _value.push({
                    ...item,
                    uid: typeof item.uid === "undefined" || item.uid === -1 ? crypto.randomUUID() : item.uid
                })

            })

            setValue(_value)
            setFirstInitial(true)
            console.log("generate new uid")
        }

        console.log("text editor value is ", value)


    }, [value, firstInitial])

    function detectEditorValue(content, priority) {

        switch (content.type) {
            case EditorItemType.HTML:
                return <RaikoEditorHtmlEditor
                    value={content.html}
                    uid={content.uid}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.IMAGE:
                return <InternalImageSelector
                    value={content.id}
                    uid={content.uid}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.IMAGE_SLIDER:
                return <InternalImageSliderSelector
                    value={content.ids}
                    uid={content.uid}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.INTERNAL_VIDEO:
                return <InternalVideoSelector
                    value={content.id}
                    uid={content.uid}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            case EditorItemType.INTERNAL_SOUND:
                return <InternalAudioSelector
                    value={content.id}
                    uid={content.uid}
                    editorValue={value}
                    priority={priority}
                    setEditorValue={setValue}
                />
            default:
                return <div>NOT FOUND SUITABLE COMPONENT</div>
        }
    }

    return (
        <>
            <RaikoGridOneColumn className={"baseEditorContainer"}>
                {
                    value && value.length > 0 ?
                        <CreateNewItem location={-1} value={value} setValue={setValue}/>
                        : ""
                }
                {
                    value && value.length > 0 ? value.map((item, index) => {
                            return <div key={item.content.uid ? item.content.uid : index}>
                                <RaikoEditorItemsContainer value={value} setValue={setValue} priority={item.priority}>
                                    {
                                        detectEditorValue(item.content, item.priority)
                                    }
                                </RaikoEditorItemsContainer>
                                <CreateNewItem location={index} value={value} setValue={setValue}/>
                            </div>
                        }) :
                        <RaikoGridOneColumn>
                            <RaikoErrorSection
                                title={"هیچ محتوایی یافت نشد"}
                                subTitle={"لطفا برای شروع یکی از محتواهای زیر را انتخاب نمایید."}
                                image={RaikoErrorSectionVectors.WRITER}
                            >
                                <div className={"firstContentLayout"}>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.HTML, -1)}>
                                        <div className={"textEditorIcon-icon"}/>
                                        <span>متن</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.IMAGE, -1)}>
                                        <div className="pictureIcon-icon"/>
                                        <span>تصویر تکی</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.IMAGE_SLIDER, -1)}>
                                        <div className="sliderIcon-icon"/>
                                        <span>اسلایدر</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.INTERNAL_VIDEO, -1)}>
                                        <div className="videoIcon-icon"/>
                                        <span>ویدیو</span>
                                    </div>
                                    <div className={"contentBaseLayout"}
                                         onClick={_ =>
                                             handleAddNewItem(value, setValue, EditorItemType.INTERNAL_SOUND, -1)}>
                                        <div className="soundIcon-icon"/>
                                        <span>صوت</span>
                                    </div>

                                </div>

                            </RaikoErrorSection>
                        </RaikoGridOneColumn>
                }
            </RaikoGridOneColumn>
        </>
    )

}


export const EditorItemType = {
    "HTML": "HTML",
    "TEXT": "TEXT",
    "IMAGE_SLIDER": "INTERNAL_IMAGE_SLIDER",
    "IMAGE": "INTERNAL_IMAGE",
    "INTERNAL_VIDEO": "INTERNAL_VIDEO",
    "INTERNAL_SOUND": "INTERNAL_SOUND",
}


export function changeContent(value = [], setValue, newContent, priority) {
    const _value = []


    if (value && value.length > 0) {
        value.map((item, index) => {
            if (parseInt(item.priority) === parseInt(priority)) {
                _value.push({
                    priority,
                    ...newContent
                })
            } else {
                _value.push(item)
            }
        })
    }

    setValue(_value)
}

export function prepareEditorItem(value, type, uid = crypto.randomUUID()) {


    switch (type) {
        case EditorItemType.HTML:
            return {
                content: {
                    uid,
                    html: value,
                    type: EditorItemType.HTML
                }
            }
        case EditorItemType.IMAGE:
            return {
                content: {
                    uid,
                    id: value,
                    type: EditorItemType.IMAGE
                }
            }
        case EditorItemType.IMAGE_SLIDER:
            return {
                content: {
                    uid,
                    ids: value,
                    type: EditorItemType.IMAGE_SLIDER
                }
            }
        case EditorItemType.INTERNAL_VIDEO:
            return {
                content: {
                    uid,
                    id: value,
                    type: EditorItemType.INTERNAL_VIDEO
                }
            }
        case EditorItemType.INTERNAL_SOUND:
            return {
                content: {
                    uid,
                    id: value,
                    type: EditorItemType.INTERNAL_SOUND
                }
            }
    }
}

export function prepareEditorDefaultItem(type) {
    const uid = crypto.randomUUID();

    switch (type) {
        case EditorItemType.HTML:
            return {
                content: {
                    uid,
                    html: "",
                    type: EditorItemType.HTML
                }
            }
        case EditorItemType.IMAGE:
            return {
                content: {
                    uid,
                    id: -1,
                    type: EditorItemType.IMAGE
                }
            }
        case EditorItemType.IMAGE_SLIDER:
            return {
                content: {
                    uid,
                    ids: [],
                    type: EditorItemType.IMAGE_SLIDER
                }
            }
        case EditorItemType.INTERNAL_VIDEO:
            return {
                content: {
                    uid,
                    id: -1,
                    type: EditorItemType.INTERNAL_VIDEO
                }
            }
        case EditorItemType.INTERNAL_SOUND:
            return {
                content: {
                    uid,
                    id: -1,
                    type: EditorItemType.INTERNAL_SOUND
                }
            }
    }
}


export function handleAddNewItem(value, setValue, type, location) {
    const _value = []

    if (value && value.length > 0 && location === -1) {
        _value.push(prepareEditorDefaultItem(type))
    }

    if (value && value.length > 0)
        value.map((item, index) => {
            _value.push(item)

            if (index === location) {
                _value.push(prepareEditorDefaultItem(type))
            }
        })
    else
        _value.push(prepareEditorDefaultItem(type))

    setValue([])

    _value.map((item, index) => {
        setValue(prev => [
            ...prev,
            {
                ...item,
                priority: index
            }
        ])
    })
}